import { icClose } from '@vivareal/lina-icons'
import { getAmenityText } from '@/utils/filters'
import tracker from './oz-filters-applied.tracker'

export default {
  name: 'oz-filters-applied',

  props: {
    amenities: { type: Array, default: () => [] },
  },

  data () {
    return {
      selectedAmenities: [],
      icons: {
        icClose,
      },
    }
  },

  created () {
    this.selectedAmenities = Array.isArray(this.amenities) ? this.amenities : []
  },

  watch: {
    amenities () {
      this.selectedAmenities = this.amenities
    },
  },

  computed: {
    showFiltersApplied () {
      return this.selectedAmenities.length
    },
  },

  methods: {
    onClickPill (pill) {
      this.selectedAmenities = this.selectedAmenities.filter((amenitie) => !(amenitie === pill))

      tracker.trackRemovedFilter()

      this.$emit('filters:update', { amenities: this.selectedAmenities })
    },

    amenityText (pill) {
      return getAmenityText(pill)
    },
  },
}
